// ================================
// Blog filter — AJAX filtering for fsbp / fsbj sections
// Intercepts clicks on filter <a> links, fetches the tagged URL,
// replaces only the grid in-page, updates filter UI in JS,
// and pushes the URL (with ?view param) to history.
// ================================

function createLoader() {
  if (!document.getElementById('fsb-filter-spin-style')) {
    const style = document.createElement('style');
    style.id = 'fsb-filter-spin-style';
    style.textContent = '@keyframes fsb-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
  }

  const loader = document.createElement('div');
  loader.className = 'fsb-filter-loader';
  loader.setAttribute('aria-hidden', 'true');
  Object.assign(loader.style, {
    position: 'absolute',
    inset: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255,255,255,0.55)',
    zIndex: '10',
    pointerEvents: 'none',
  });
  loader.innerHTML =
    '<div style="width:36px;height:36px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:fsb-spin 0.7s linear infinite"></div>';
  return loader;
}

function closeDropdown(link) {
  const dropdown = link.closest('[data-filter]');
  if (!dropdown) return;
  const btn = dropdown.querySelector('[aria-expanded]');
  const menu = dropdown.querySelector('.fsbp__dropdown-menu, .fsbj__dropdown-menu');
  if (btn) btn.setAttribute('aria-expanded', 'false');
  if (menu) menu.setAttribute('hidden', '');
}

/**
 * @param {HTMLAnchorElement} clickedLink
 * @param {boolean} isProjects
 */
function updateFilterUI(clickedLink, isProjects) {
  const prefix = isProjects ? 'fsbp' : 'fsbj';
  const dropdown = clickedLink.closest('[data-filter]');
  if (!dropdown) return;

  // Mark the clicked option as selected, clear others in this dropdown
  dropdown.querySelectorAll(`.${prefix}__dropdown-option`).forEach((opt) => {
    opt.classList.toggle('is-selected', opt === clickedLink);
  });

  const isAll = clickedLink.textContent.trim() === 'All';
  dropdown.classList.toggle('is-active', !isAll);

  const labelEl = /** @type {HTMLElement|null} */ (dropdown.querySelector(`.${prefix}__dropdown-label`));
  if (labelEl) {
    // Store the original label on first use
    if (!labelEl.dataset.defaultLabel) {
      labelEl.dataset.defaultLabel = labelEl.textContent.trim();
    }
    labelEl.textContent = isAll
      ? labelEl.dataset.defaultLabel
      : clickedLink.textContent.trim().toUpperCase();
  }
}

function initBlogFilters() {
  document.addEventListener('click', (e) => {
    const target = /** @type {HTMLElement|null} */ (e.target);
    const link = /** @type {HTMLAnchorElement|null} */ (
      target && target.closest('a.fsbp__dropdown-option, a.fsbj__dropdown-option')
    );
    if (!link) return;

    e.preventDefault();
    closeDropdown(link);

    const isProjects = link.classList.contains('fsbp__dropdown-option');
    const gridSelector = isProjects ? '#fsbp-grid'       : '.fsbj__columns';
    const viewParam    = isProjects ? '4spaces-projects' : '4spaces-journal';

    const grid = /** @type {HTMLElement|null} */ (document.querySelector(gridSelector));
    if (!grid) return;

    // --- Build multi-tag URL ---
    // Determine which filter category was clicked (e.g. "project-type", "designer")
    const dropdown = link.closest('[data-filter]');
    const filterKey = dropdown instanceof HTMLElement ? dropdown.dataset.filter || '' : '';

    // Extract the handleized tag from the clicked link path (null = "All")
    const linkUrl = new URL(link.href, window.location.origin);
    const tagMatch = linkUrl.pathname.match(/\/tagged\/(.+)/);
    const newTag = tagMatch ? tagMatch[1] : null;

    // Get blog base path (strip /tagged/... if present)
    const blogBase = linkUrl.pathname.replace(/\/tagged\/.+/, '').replace(/\/$/, '');

    // Parse current active tags from the current URL
    const currentTagMatch = window.location.pathname.match(/\/tagged\/([^?]+)/);
    const currentTags = currentTagMatch ? (currentTagMatch[1] || '').split('+').filter(Boolean) : [];

    // Remove tags belonging to this category, then add the new one (if not "All")
    const updatedTags = currentTags.filter((t) => !filterKey || !t.startsWith(filterKey + '_'));
    if (newTag) updatedTags.push(newTag);

    const cleanUrl = updatedTags.length > 0
      ? `${linkUrl.origin}${blogBase}/tagged/${updatedTags.join('+')}`
      : `${linkUrl.origin}${blogBase}`;

    const fetchUrl = new URL(cleanUrl);
    fetchUrl.searchParams.set('view', viewParam);

    // Show loader over the grid
    const loader = createLoader();
    grid.style.position = 'relative';
    grid.appendChild(loader);

    fetch(fetchUrl.toString())
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.querySelector(gridSelector);
        if (newGrid) grid.replaceWith(newGrid);

        updateFilterUI(link, isProjects);
        history.pushState({}, '', fetchUrl.toString());
      })
      .catch(() => {
        window.location.href = cleanUrl;
      })
      .finally(() => {
        loader.remove();
      });
  });
}

document.addEventListener('DOMContentLoaded', initBlogFilters);
